export default __webpack_public_path__ + "static/media/2.099a32cc.png";